import { render, staticRenderFns } from "./SearchRecipients_4_2.vue?vue&type=template&id=2c8ebdee&"
import script from "./SearchRecipients_4_2.vue?vue&type=script&lang=js&"
export * from "./SearchRecipients_4_2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports